import * as React from "react";
import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import { LoadingButtonProps } from "./useLoadingButton";
import LoadingButton from "./LoadingButton";
import { UCLColors, UCLColorKey } from "../colors/uclColors";

export interface SecondaryButtonProps
  extends Omit<
    LoadingButtonProps,
    | "buttonClassStyle"
    | "defaultLoadingIdleContent"
    | "defaultLoadingProgressContent"
    | "defaultLoadingSuccessContent"
  > {
    color?: UCLColorKey;
    children?: React.ReactNode | React.ReactNode[];
  }

/**No defaults set, with secondary styling*/
const SecondaryButton: React.FC<
  SecondaryButtonProps & Readonly<DefaultHtmlAttributes>
> = (props) => {
  // Use color prop as UCLColorKey, otherwise undefined
  const resolvedColor = props.color ? UCLColors[props.color] : undefined;

  return (
    <LoadingButton
      {...props}
      buttonClassStyle="e-info"
      defaultLoadingIdleContent=""
      defaultLoadingProgressContent="Loading"
      defaultLoadingSuccessContent="Loaded"
      cssClass={props.cssClass + " ucl-secondary-button"}
      style={resolvedColor ? {
        background: 'transparent',
        color: resolvedColor,
        border: `2px solid ${resolvedColor}`,
        ...(props.style || {})
      } : props.style}
    />
  );
};
export default SecondaryButton;
